import { Dialog } from '@mui/material';
import { useEffect, useState } from 'react';
import EmoteIcon from '../../../assets/Posts/EmoteIcon';
import FacebookIcon from '../../../assets/Profile/FacebookIcon';
import TelegramIcon from '../../../assets/Profile/TelegramIcon';
import WhatsAppIcon from '../../../assets/Profile/WhatsApp';
import XIcon from '../../../assets/Profile/XIcon';
import { useMessages } from '../../../contexts/messages';
import { api } from '../../../services/api';
import { UserType } from '../../../services/apiTypes';
import Button from '../../Button';
import InputLogin from '../../InputLogin';
import User from '../../User';
import { FollowText } from '../../User/styles';
import {
  ButtonsContainer,
  CommentPlaceholder,
  CommentSection,
  Container,
  Header,
  HeaderClose,
  HeaderText,
  LinkContainer,
  LinkText,
  SelectedIcon,
  SelectionContainer,
  SelectionItem,
  SelectionList,
  SelectionText,
  SocialsContainer
} from './styles';

type PostModalProps = {
  authorUsername: string;
  id: string;
  open: any;
  onClose: any;
};

export default function SharePostModal({ authorUsername, id, open, onClose }: PostModalProps) {
  const [searchInput, setSearchInput] = useState();
  const [selectedUsers, setSelectedUsers] = useState<any>([]);
  const [users, setUsers] = useState<UserType[]>([]);
  const [copied, setCopied] = useState<boolean>(false);
  const [comment, setComment] = useState('');
  const { sendMessage } = useMessages();

  const handleSelectUser = (user: any) => {
    if (selectedUsers.includes(user)) {
      setSelectedUsers(selectedUsers.filter((u: any) => u !== user));
    } else {
      setSelectedUsers([...selectedUsers, user]);
    }
  };

  useEffect(() => {
    try {
      api.get(`/users/`).then(response => {
        setUsers(response.data)
      }, error => {
        console.error(error);
      }
      );
    } catch (error) {
      console.error(error);
    }
  }, []);

  const handleCopyText = () => {
    navigator.clipboard.writeText(`${window.location.origin}/${id}`)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  const handleShare = async () => {
    const payload = {
      parentId: id,
      receiverId: selectedUsers[0].id,
      content: comment + `${window.location.origin}/${id}`,
    };
    console.log('payload', payload);
    sendMessage(payload);
    onClose(false);
  }

  return (
    <Dialog
      open={open && users.length > 0}
      onClose={() => onClose(false)}
      disableEnforceFocus={true}
      maxWidth={false}
      PaperProps={{ sx: { borderRadius: "32px" } }}
      style={{
        display: 'flex',
        backgroundColor: 'rgba(27, 27, 27, 0.85)',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Container>
        <Header>
          <div />
          <HeaderText>Compartilhar</HeaderText>
          <HeaderClose onClick={() => onClose(false)}>
            <Close />
          </HeaderClose>
        </Header>
        <SelectionContainer>
          <SelectionText>Com seus amigos</SelectionText>
          <InputLogin
            icon={<Search />}
            placeholder='Buscar amigo'
            handler={(e) => setSearchInput}
          />
          <SelectionList>
            {users.map((user, index) => (
              <SelectionItem key={index}>
                <User icon={user.avatarUrl} username={user.username} />
                <SelectedIcon onClick={() => handleSelectUser(user)}>
                  {selectedUsers.includes(user) ? <Selected /> : <NotSelected />}
                </SelectedIcon>
              </SelectionItem>
            ))}
          </SelectionList>
          {selectedUsers.length > 0 ? (
            <>
              <CommentSection>
                <CommentPlaceholder placeholder='Adicione um comentário' onChange={(e) => setComment(e.target.value)} />
                <EmoteIcon />
              </CommentSection>
              <Button
                theme="dark"
                text="Enviar"
                height={44}
                onClick={() => handleShare()}
              />
            </>
          ) : (
            <div style={{ gap: 40 }}>
              <SocialsContainer>
                <SelectionText>Compartilhe nas redes sociais</SelectionText>
                <ButtonsContainer>
                  <FacebookIcon />
                  <XIcon />
                  <WhatsAppIcon />
                  <TelegramIcon />
                </ButtonsContainer>
              </SocialsContainer>
              <SocialsContainer>
                <SelectionText>Copiar o link</SelectionText>
                <LinkContainer>
                  <LinkText>
                    {window.location.origin + '/' + id}
                  </LinkText>
                  <FollowText onClick={() => handleCopyText()}>
                    {copied ? 'Copiado' : 'Copiar'}
                  </FollowText>
                </LinkContainer>
              </SocialsContainer>
            </div>
          )}
        </SelectionContainer>
      </Container>
    </Dialog>
  );
}

function Close() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      fill="none"
      viewBox="0 0 17 17"
    >
      <path
        fill="#999"
        d="M8.667 6.89L14.889.666l1.778 1.777-6.223 6.223 6.223 6.222-1.778 1.778-6.222-6.223-6.223 6.223-1.777-1.778 6.222-6.222L.667 2.444 2.444.667l6.223 6.222z"
      ></path>
    </svg>
  );
}

function Search() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#999"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35"
      ></path>
    </svg>
  );
}

function NotSelected() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#999"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
      ></path>
    </svg>
  );
}

function Selected() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#6E30E8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7.5 12l3 3 6-6m5.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
      ></path>
    </svg>
  );
}
